import { Location } from '../../dto/c4/location/index';
import { IS_NOT_EMPTY } from '../../utils/stringUtils/string-utils';
import { TruckSearchTable } from '../../searchTrucks/views';
import { CAMEL_CASE } from '../stringUtils';
import { DISPLAY_STATE } from './mexican-states-display';

// US: 12345 or 12345-6789
const US_ZIP_RE = /^\d{5}(?:-\d{4})?$/;

// Canada: A1A 1A1 (space optional), with Canada Post’s allowed letters
const CA_POSTAL_RE = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\s?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

const IS_VALID_ZIPCODE = (v?: string | null): boolean => {
	const z = v?.trim();
	if (!z) return false;
	return US_ZIP_RE.test(z) || CA_POSTAL_RE.test(z);
};

/**
 * @deprecated Use `FORMAT_LOCATION` instead.
 */
export const LOCATION_PARSER = (location: Location): string => {
	let cleanZip = null;
	if (location.zip) {
		cleanZip = location.zip?.trim();
	} else if (location.postcode) {
		cleanZip = location.postcode?.trim();
	}
	let result = '';
	if (IS_NOT_EMPTY(location.city)) {
		result = CAMEL_CASE(location.city.trim());
	}
	if (IS_NOT_EMPTY(location.state)) {
		result += (result.length > 0 ? ', ' : '') + DISPLAY_STATE(location.state);
	}
	if (IS_NOT_EMPTY(cleanZip) && IS_VALID_ZIPCODE(cleanZip)) {
		result += (result.length > 0 ? ', ' : '') + cleanZip;
	}
	return result;
};

export const POPULATE_ORIGIN = (truck: TruckSearchTable, location: Location) => {
	truck.originCity = location.city;
	truck.originState = location.state;
};

export const POPULATE_DESTINATION = (truck: TruckSearchTable, location: Location) => {
	truck.destCity = location.city;
	truck.destState = location.state;
};

export const HQ_LOCATION_PARSER = (
	city: string,
	state: string,
	country: string = '',
	appendCountry: boolean = false
): string => {
	let hqLocation = '';
	if (IS_NOT_EMPTY(city) || IS_NOT_EMPTY(state)) {
		if (IS_NOT_EMPTY(city) && IS_NOT_EMPTY(state)) {
			hqLocation = `${CAMEL_CASE(city?.trim())} , ${DISPLAY_STATE(state)}`;
		} else if (IS_NOT_EMPTY(city)) {
			hqLocation = CAMEL_CASE(city?.trim());
		} else {
			hqLocation = DISPLAY_STATE(state);
		}
	}
	if (appendCountry && IS_NOT_EMPTY(country)) {
		hqLocation += (hqLocation.length > 0 ? ', ' : '') + country?.trim();
	}
	return hqLocation;
};

export const LOCATION_PARSER_WITHOUT_ZIP = (location: Location): string => {
	let result = '';
	if (IS_NOT_EMPTY(location.city)) {
		result = CAMEL_CASE(location?.city?.trim());
	}
	if (IS_NOT_EMPTY(location.state)) {
		result += (result.length > 0 ? ', ' : '') + DISPLAY_STATE(location.state);
	}
	return result;
};

export const GET_CITY_STATE_FROM_LOCATION_STRING = (
	location: string
): { city: string; state: string } => {
	let result = { city: '', state: '' };
	if (IS_NOT_EMPTY(location)) {
		let stringSplit = location.split(',');
		result = {
			...result,
			city: IS_NOT_EMPTY(stringSplit[0]) ? stringSplit[0].trim() : '',
			state: IS_NOT_EMPTY(stringSplit[1]) ? stringSplit[1].trim() : '',
		};
	}
	return result;
};

export const FORMAT_LOCATION = (
	city: string | null,
	state: string | null,
	zip: string | null,
	appendZip: boolean = true,
	country: string | null = null,
	appendCountry: boolean = false
): string => {
	const cleanCity = city?.trim() ? CAMEL_CASE(city!.trim()) : '';
	const cleanState = state?.trim() ? DISPLAY_STATE(state) : '';
	const cleanZip = zip?.trim() ?? '';
	const cleanCountry = country?.trim() ?? '';
	const parts = [
		cleanCity,
		cleanState,
		appendZip && IS_VALID_ZIPCODE(cleanZip) ? cleanZip : '',
		appendCountry ? cleanCountry : '',
	].filter(Boolean);

	return parts.length === 0 ? '' : parts.join(', ');
};

export const BUILD_LANE = (
	origin?: string | null,
	destination?: string | null,
	equipmentTypes?: string | null
): string => {
	const parts: string[] = [];

	if (origin && destination) {
		parts.push(`${origin} → ${destination}`);
	} else if (origin) {
		parts.push(origin);
	} else if (destination) {
		parts.push(destination);
	}

	if (equipmentTypes) {
		parts.push(`(${CAMEL_CASE(equipmentTypes)})`);
	}

	return parts.length > 0 ? parts.join(' ') : 'N/A';
};
